import { getLogger } from '../../diagnostics/logger';
import * as Redux from 'redux';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { ENSURE_COMMAND_TYPES, INITIAL_AUTHENTICATION, LOAD_COMMAND_TYPES } from '../../actions/actionTypes';
import {
  loadCommandTypes,
  loadCommandTypesFailure,
  loadCommandTypesPending,
  loadCommandTypesSuccess,
} from '../../actions/commandTypeActions';
import * as commandTypeApi from '../../api/commandTypeApi';
import { HashMap } from '../../constants';
import { CommandTypesPayload, CommandTypesState } from '../../models/state/commandTypeState';
import { selectCommandTypes } from '../../selectors/commandTypes';

const log = getLogger('simmanagement.sagas.login');

/**
 * Ensure that the command types have been loaded.
 * @param action The action that invoked the saga.
 */
export function* ensureCommandTypesSaga(action: Redux.Action) {
  const commandTypes: CommandTypesState = yield select(selectCommandTypes);
  if ((!commandTypes.expiresOn || commandTypes.expiresOn < new Date()) && !commandTypes.isLoading) {
    yield put(loadCommandTypes());
  }
}

/**
 * Load the command types.
 * @param action The action that invoked the saga.
 */
export function* loadCommandTypesSaga(action: Redux.Action) {
  yield put(loadCommandTypesPending());
  try {
    const commandTypes: CommandTypesPayload = yield call(commandTypeApi.get);
    yield put(loadCommandTypesSuccess(commandTypes));
  } catch (error: any) {
    yield put(loadCommandTypesFailure(error));
  }
}

/*
 * Initialize all sagas related to command types.
 */
export function* initCommandTypesSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ENSURE_COMMAND_TYPES, ensureCommandTypesSaga);
  yield takeEvery(LOAD_COMMAND_TYPES, loadCommandTypesSaga);
}
